import {Helper} from "../models/HelperClasses";
export abstract class ConvertableFromApi<T> {

    public readonly objectFromApi: any;
    public readonly timestamp: number = 0;
    public readonly refreshedAt: string;
    abstract createNew(element: any): T;
  
    constructor(data?: any) {
      if (data === null || data === undefined) {
        this.objectFromApi = null;
        this.timestamp = 0;
        this.refreshedAt = "";
        return;
      }
  
      this.timestamp = Date.now();
      this.refreshedAt = Helper.ticksToTime(this.timestamp)
      this.objectFromApi = data;
    }
  }
